import React from 'react'

/**
 * Generate a consistent color based on a string (like initials or email)
 * Uses a simple hash to pick from a set of nice background colors
 */
function stringToColor(str) {
  const colors = [
    'bg-red-500',
    'bg-orange-500',
    'bg-amber-500',
    'bg-yellow-500',
    'bg-lime-500',
    'bg-green-500',
    'bg-emerald-500',
    'bg-teal-500',
    'bg-cyan-500',
    'bg-sky-500',
    'bg-blue-500',
    'bg-indigo-500',
    'bg-violet-500',
    'bg-purple-500',
    'bg-fuchsia-500',
    'bg-pink-500',
    'bg-rose-500'
  ]

  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }

  return colors[Math.abs(hash) % colors.length]
}

/**
 * Avatar component showing user initials with a consistent background color
 */
export default function Avatar({
  initials,
  size = 'md',
  className = '',
  onClick
}) {
  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base',
    xl: 'w-16 h-16 text-xl'
  }

  const bgColor = stringToColor(initials || '')

  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        ${sizeClasses[size] || sizeClasses.md}
        ${bgColor}
        inline-flex items-center justify-center
        rounded-full text-white font-medium
        hover:opacity-90 transition-opacity
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500
        ${className}
      `}
    >
      {initials}
    </button>
  )
}
